module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"closed":"Closed","d1":"Channel 1","d2":"Channel 2","open":"Open"},"de":{"closed":"Geschlossen","d1":"Kanal 1","d2":"Kanal 2","open":"Offen"},"fr":{"closed":"Fermé","d1":"Canal 1","d2":"Canal 2","open":"Ouvert"},"it":{"closed":"Closed","d1":"Channel 1","d2":"Channel 2","open":"Open"}}')
  delete Component.options._Ctor
}
